import { List } from '@athena/forge';
import EnrollItemClassic from './classic/EnrollItem';
import EnrollItemOie from './oie/EnrollItem';
import ChallengeItem from './oie/ChallengeItem';
import ProxyButton from '../common/ProxyButton';
import athenaConfig from '../../config';

const { classic } = athenaConfig;

export interface FactorListPropTypes {
    oktaFactorsList: JQuery;
    challenge?: boolean;
    oktaSubmitButton?: JQuery;
    title?: string;
    onClick?: (buttonText?: string) => void;
    isEnrolledFactor?: boolean;
}

export default function FactorsList({
  oktaFactorsList,
  oktaSubmitButton,
  challenge,
  title,
  onClick,
  isEnrolledFactor = false,
}: FactorListPropTypes) {
  const EnrollItem = classic ? EnrollItemClassic : EnrollItemOie;
  const ItemComponent = challenge ? ChallengeItem : EnrollItem;
  return (
    <>
      {title && <h3 className="fe_u_margin--bottom-large fe_u_font-weight--semibold">{title}</h3>}
      <List className="fe_u_margin--bottom-medium">
        {oktaFactorsList.map((index) => {
          const oktaFactorItem = oktaFactorsList.eq(index);
          return (
            <ItemComponent
              key={index}
              oktaFactorItem={oktaFactorItem}
              lastItem={index === oktaFactorsList.length - 1}
              isEnrolledFactor={isEnrolledFactor}
            ></ItemComponent>
          );
        })}
      </List>
      {oktaSubmitButton && oktaSubmitButton.length > 0 && (
        <div className="fe_u_margin--top-large fe_u_margin--bottom-large">
          <ProxyButton fullWidth oktaButton={oktaSubmitButton} size="large" variant="primary" onClick={onClick} />
        </div>
      )}
    </>
  );
}
